const newStandardPageIds = [
  'standardSelect'
];

newStandardPageIds.forEach(id => {
  $('#' + id).selectize();
});
